<template>
<div>
    <!-- Home Start-->
    <section class="main-header bg-header talent-banner-img">
        <div class="home-bg-img">
            <div class="container">
                <div>
                    <div class="item">
                        <div class="row align-items-center">
                            <div class="col-lg-7">
                                <div class="content wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                                    <h2 class="banner-title text-lg-left text-center text-white text-uppercase">
                                        TALENT ASSESSMENT
                                    </h2>
                                    <p class="text-white text-lg-left text-center para-txt font-weight-medium f-16">
                                        <b class="sub-title">Talent is a key spoke in your organization’s wheel</b><br><br> Our Productive-Employee Model outlines that employees’ outputs are maximized by their personal-growth ambitions and the rewards and perks that an organization provides.
                                    </p>
                                </div>
                            </div>
                            <sales-lead-form product="Talent Optimizer Assesment"> </sales-lead-form>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <section class="section services-top">
        <div class="container">
            <div class="services-main">
                <div class="row align-items-center">
                    <div class="col-md-12">
                        <img src="assets/images/assessments/talent-assessment.png" alt="service-tab.png" class="w-100 img-fluid">
                    </div>

                    <section class="section bg-light">
                        <div class="container">
                            <div class="row align-items-baseline">
                                <div class="col-lg-6 wow fadeInUp" data-wow-duration="1500ms">
                                    <div class="title-section">
                                        <div class="subtitle-hr d-flex align-items-center">
                                            <h6 class="subtitle theme-color text-uppercase position-relative">TALENT ASSESSMENT</h6>
                                            <hr>
                                        </div>
                                        <h2 class="title text-md-left text-center f-30">What are the components of this assessment?</h2>
                                    </div>
                                    <div class="mt-4">
                                        <div id="accordion" class="wow fadeInUp" data-wow-duration="1500ms">
                                            <div class="accordion-card bg-white mb-4 shadow rounded active">
                                                <div class="card-header border-0 p-0" id="headingOne">
                                                    <h5 class="mb-0">
                                                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"><span class="font-weight-medium">Talent Optimizer
                                                                Strategic Assessment
                                                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                                    </h5>
                                                </div>
                                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                                    <div class="pt-2">
                                                        <p class="m-0">
                                                            The assessment helps you answer whether your organization has an adequate talent management program to onboard and nurture the best talent.
                                                        </p>
                                                        <img src="assets/images/assessments/optimizer.png" alt="service-tab.png" class="w-100 img-fluid">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                                <div class="card-header border-0 p-0" id="headingTwo">
                                                    <h5 class="mb-0">
                                                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"><span class="font-weight-medium">Functional
                                                                Competency Assessments
                                                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                                    </h5>
                                                </div>
                                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                                    <div class="pt-2">
                                                        <p class="m-0">
                                                            Our functional competency assessments take the guessing out of the function of each staff member. This is a self-assessment tool for all levels of staff to determine if they are fulfilling the obligations of the function relative to best practices.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                                <div class="card-header border-0 p-0" id="headingThree">
                                                    <h5 class="mb-0">
                                                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"><span class="font-weight-medium">Global Consulting Readiness
                                                                Competency Assessment
                                                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                                                    </h5>
                                                </div>
                                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                                    <div class="pt-2">
                                                        <p class="m-0">
                                                            Leaders and consultants should take this assessment to determine if they are a 21st Century leader
                                                        </p>
                                                        <img src="assets/images/assessments/competency.png" alt="service-tab.png" class="w-100 img-fluid">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 mt-lg-0 mt-6">
                                    <div class="wow fadeInUp" data-wow-duration="1500ms">
                                        <div class="title-section">
                                            <div class="subtitle-hr d-flex align-items-center">
                                                <h6 class="subtitle theme-color text-uppercase position-relative">Get started now</h6>
                                                <hr>
                                            </div>
                                            <!-- <h2 class="title text-md-left text-center f-40">Meet our Team</h2> -->
                                        </div>
                                    </div>
                                    <div class="mt-4 wow fadeInUp" data-wow-duration="1500ms">
                                        <img src="assets/images/assessments/business-person.png" alt="service-tab.png" heigh="200">
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    </section>

    <!-- End Services Top -->

    <steps></steps>

    <section class="section bg-light">
        <div class="container">
            <div class="row align-items-baseline">
                <faqs></faqs>
                <assessment-listing></assessment-listing>
            </div>
        </div>
    </section>
   
    <promotions></promotions>
    <contact-form></contact-form>
</div>
</template>

<script>
//WOW JS
import {
    WOW
} from 'wowjs';
//OWL CAROUSEL JS
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

import SalesLeadForm from '../layouts/salesLeadForm.vue';
import ContactForm from '../layouts/contactForm.vue';
import AssessmentListing from '../layouts/assessmentListing.vue';
import Steps from '../layouts/steps.vue';
import Faqs from '../layouts/faqs.vue';
import Promotions from '../layouts/promotions.vue';


export default {
    name: 'index',
    selected: '',
    mounted() {
        this.init();
    },
    components: {
        SalesLeadForm,
        AssessmentListing,
        Steps,
        ContactForm,
        Promotions,
        Faqs,

    },
    methods: {
        init() {
            this.initMainSlider();
            this.initWowAnimation();
            this.initTeamSlider();
            this.initClientSlider();
            this.initAccordian();
        },
        computed: {
            countries() {
                const list = countries.getNames('en', {
                    select: 'official'
                })
                return Object.keys(list).map((key) => ({
                    value: key,
                    label: list[key]
                }))
            }
        },
        /*----Main Slider----*/
        initMainSlider() {
            $('.main-slider').owlCarousel({
                loop: true,
                items: 1,
                margin: 0,
                nav: true,
                dots: true,
                autoplay: false,
                autoplayTimeout: 5000,
                items: 1,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    600: {
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    1000: {
                        items: 1,
                        nav: false,
                        dots: true
                    }
                }
            });
        },
        /*----WOW ANIMATION-----*/
        initWowAnimation() {
            var length = $('.wow').length;
            if (length >= 1) {
                const wow = new WOW({
                    boxClass: 'wow',
                    animateClass: 'animated',
                    offset: 0,
                });
                wow.init();
            }
        },
        /*----TEAM SLIDER-----*/
        initTeamSlider() {
            var teamCarousel = $('.team-slider');
            if (teamCarousel.length > 0) {
                teamCarousel.owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 0,
                    nav: true,
                    dots: true,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    items: 2,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        600: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        991: {
                            items: 2,
                            nav: false,
                            dots: true
                        }
                    }
                });
            }
        },
        /*----CLIENT SLIDER-----*/
        initClientSlider() {
            var testimonialCarousel = $('.clients-slider');
            if (testimonialCarousel.length > 0) {
                testimonialCarousel.owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 0,
                    nav: true,
                    dots: true,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    items: 2,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        600: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        991: {
                            items: 2,
                            nav: false,
                            dots: true
                        }
                    }
                });
            }
        },
        /*----ACCORDIAN-----*/
        initAccordian() {
            $(".accordion-card").click(function () {
                if ($(this).hasClass('active')) {
                    $('.accordion-card').removeClass('active');
                    $(this).removeClass('active')
                } else {
                    $('.accordion-card').removeClass('active');
                    $(this).addClass('active')
                }
            });
        }
    }
}
</script>
